<template>
	<div class="action">
		<a-card class="visit-count">
			<div class="titles">
				优质资源申报
				<span v-hasPermission="'qualityConten:self'" @click="$router.push({ path: '/OA/awardApply' })">我的申报>></span>
				<span v-hasPermission="'qualityConten:list'" @click="$router.push({ path: '/OA/awardApplyApproval' })">申报列表>></span>
			</div>
			<a-radio-group v-model="radioType" @change="radioChange">
				<a-badge :count="todoNum"><a-radio-button value="1">待处理</a-radio-button></a-badge>
				<a-radio-button value="2">已处理</a-radio-button>
			</a-radio-group>
			<div class="home-approval">
				<ul class="approval-list">
					<li class="approval-item" v-for="(item, index) in dataList" @click="detail(item)">
						<div style="display: flex;justify-content: space-between;">
							<span class="header">{{ item.taskName }}</span>
							<span>&nbsp;</span>
						</div>
						<span class="commit-time" v-if="radioType == 1">创建时间: {{ item.createTime }}</span>
						<span class="commit-time" v-if="radioType == 2">完成时间: {{ item.operatingTime }}</span>
					</li>
				</ul>
			</div>
		</a-card>
		<QualityContentView :visible="qualityContentDialog2" @close="qualityContentDialog2 = false" @success="(qualityContentDialog2 = false), list()" ref="qualityContentDialog2"></QualityContentView>
	</div>
</template>

<script>
import QualityContentView from './qualityContentView';
export default {
	components: {
		QualityContentView
	},
    data() {
        return {
            dataList: [],
			radioType: '1',
			todoNum: 0,
			qualityContentDialog2: false,
        }
    },
	mounted() {
		this.list();
	},
    methods:{
		radioChange(e) {
			this.radioType = e.target.value;
			this.list();
		},
    	list() {
    		this.$get('flowTask/getHomePageData', {businessType: 'award', type: this.radioType }).then(res => {
    			let result = res.data;
    			this.dataList = result.dataList;
    			this.todoNum = result.count;
				this.$emit("success", this.todoNum);
    		});
    	},
		detail(record){
			this.qualityContentDialog2 = true;
			this.$refs.qualityContentDialog2.init({id: record.id});
		}
    }
}
</script>



// WEBPACK FOOTER //
// src/views/OA/qualityContent/approvalHome.vue